import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../services';
import { VolunteerDialogDataService } from '../volunteer-dialog-data.service';
import { getSetup } from './grid/get-setup';

export interface VolunteerSpecialistSignup {
	trimesterId: number,
	trimesterName: string,
	status: string,
	topicName: string,
	language: string,
	availableClassStartTimeUTC: number,
	availableClassEndTimeUTC: number,
	createdUTC: number,
	updatedUTC: number,
}

@Component({
	selector: 'volunteer-specialist-signups-dialog-part',
	standalone: true,
	imports: [
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './specialist-signups-dialog.part.html',
})
export class VolunteerSpecialistSignupsDialogPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	public readonly dialogDataService = inject(VolunteerDialogDataService);
	private readonly app = inject(AppService);
	private readonly domainData = inject(DomainDataService);

	public setup = getSetup(this.util);

	// subtracting 70 to account for padding, tabstrip
	public customHeight = computed(() => this.dialogBodyHeight() - 70);

	public specialistSignups = computed(() => {
		const data = this.dialogDataService.volunteerDetails();

		const topicMap = this.domainData.data().topicsMap;

		return data?.specialistSignups.reduce((arr, signup) => {
			const trimesterName = this.app.getTrimesterNameById(signup.trimesterId);

			signup.topics.forEach(topic => {
				arr.push({
					trimesterId: signup.trimesterId,
					trimesterName,
					status: topic.volunteerSignupSpecialistStatus,
					topicName: topicMap[topic.topicId]!.name, // topicMap have all topics loaded, so this is safe
					language: topic.languageId === LanguageId.Espanol ? 'Spanish' : 'English',
					availableClassStartTimeUTC: topic.availableClassStartTimeUTC,
					availableClassEndTimeUTC: topic.availableClassEndTimeUTC,
					createdUTC: signup.createdUTC,
					updatedUTC: signup.updatedUTC,
				})
			})

			return arr;
		}, [] as VolunteerSpecialistSignup[]) ?? [];
	});


}
